export default "__VITE_ASSET__CFfUMdfy__"